import { Request } from '@/classes/Request.ts'

export const login = async (username: string, password: string): Promise<void | string> => {
  return new Promise((resolve, reject) => {
    new Request()
      .post('/ajax/login', { username: username, password: password })
      .then(() => {
        resolve()
      })
      .catch((err: any) => {
        if (err.response.status === 400) {
          reject('Log-in failed, missing username and/or password')
        }
        if (err.response.status === 401) {
          reject('Log-in failed, invalid username or password')
        }
        if (err.response.status === 429) {
          reject('Log-in failed, please wait and try again later')
        }
        if (err.response.status === 500) {
          reject('Log-in failed, server error')
        }
        reject('Log-in failed, unknown reason')
      })
  })
}
